import { useContext } from "react";
import { ConfigContext } from "../providers/ConfigContext";
import useMakeApiRequest from "./useMakeApiRequest";

const useGetWalletTransaction = () => {
  const { apiBase } = useContext(ConfigContext);
  const makeApiRequest = useMakeApiRequest("GET");

  const getTransaction = async (walletId: any) => await makeApiRequest(`${apiBase}/api/wallets/${walletId}/transactions`, {});

  return [getTransaction];
};

export default useGetWalletTransaction;
